import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  clearRecentSearches, recentSearchToParams, RecentSearch, removeRecentSearch,
} from '../lib/recentSearches';

interface RecentSearchActions {
  resume: (s: RecentSearch) => void;
  resumeWithGrade: (s: RecentSearch, grade: string) => void;
  remove: (id: string) => void;
  clearAll: () => void;
}

/** Navigation + mutation handlers shared by the recents card and drawer. */
export const useRecentSearchActions = (): RecentSearchActions => {
  const navigate = useNavigate();

  const resume = useCallback(
    (s: RecentSearch) => navigate(`/results?${recentSearchToParams(s)}`, {
      state: { enteredFrom: 'recent_search' },
    }),
    [navigate],
  );

  const resumeWithGrade = useCallback(
    (s: RecentSearch, grade: string) => navigate(
      `/results?${recentSearchToParams({ ...s, grade })}`,
      { state: { enteredFrom: 'recent_search' } },
    ),
    [navigate],
  );

  return {
    resume,
    resumeWithGrade,
    remove: removeRecentSearch,
    clearAll: clearRecentSearches,
  };
};
